module.exports = __webpack_public_path__ + "static/media/ic_hanger.45b9c108.svg";